import { Selector } from '@ngxs/store';
import { LanguageInfo } from '../configuration';
import { LanguageState } from './language.state';
import { LanguageStateModel } from './language.types';

export class LanguageSelectors {
  @Selector([LanguageState])
  static getLangs({ languages }: LanguageStateModel): LanguageInfo[] {
    return languages;
  }

  @Selector([LanguageState])
  static getCurrentLang({ currentLang }: LanguageStateModel): LanguageInfo | null {
    return currentLang;
  }

  @Selector([LanguageState])
  static getDefaultLang({ defaultLang }: LanguageStateModel): LanguageInfo | null {
    return defaultLang;
  }
}
